export default "__VITE_PUBLIC_ASSET__c2935c33__"